import Swiper from "swiper11";
import { Thumbs } from "swiper11/modules";
import { createdThumbs } from "../utils/utils";

const SMO = () => {
  const pageMarker = $("._SMO_");
  if (!pageMarker.length) return;

  new Swiper(pageMarker.find(".smo-advantage .swiper-box.main .swiper")[0], {
    modules: [Thumbs],
    loop: true,
    slidesPerView: 1,
    spaceBetween: 60,
    speed: 1000,
    on: {
      beforeInit: (swiper) => {
        createdThumbs(swiper, ".smo-advantage .swiper-box.thumbs .swiper", {
          cloneTarget: "*[data-clone]",
          swiperOptions: {
            slidesPerView: "auto",
            direction: "horizontal",
            spaceBetween: 15,
            breakpoints: {
              621: {
                direction: "vertical",
              },
            },
          },
        });
      },
    },
  });
};

export default SMO;
